function jQueryLogic() {
    let isDesktopActive = false;
    let isMobileActive = false;
    let isMobile = false;

    function clearMobile() {
        $('#app,#app-ssr').removeClass('filter-is-open');
        $('#filter-wrapper').removeClass('show-filter');
        $('.filter-container').removeClass('show-on-mobile');
        $('.filter-navigation').removeAttr("style");
        $('.filter-content').removeClass('show-on-mobile');
        $('.filter-content-entry').removeClass('show-on-mobile');
    }

    function clearDesktop() {
        $('#app,#app-ssr').removeClass('filter-is-open');
        $('.filter-container').removeAttr("style");
        $('.filter-navigation-entry').removeClass('active');
        $('.filter-content > .filter-content-entry').removeAttr("style");
    }

    function clearAll() {
        if (isMobile) {
            clearMobile();
        } else {
            clearDesktop();
        }
    }

    $('.filter-navigation-entry').off().on('click', function () {
        const target = $(this).data('target-tab');
        if (!isMobile && target) {
            isDesktopActive = true;

            // remove any old active filter styling
            $('.filter-navigation-entry').removeClass('active');
            $('.filter-content > .filter-content-entry').hide();

            // add styling to current selected filter
            $('#app,#app-ssr').addClass('filter-is-open');
            $('.filter-container').show();
            $(this).addClass('active');
            $('.filter-content > .filter-content-entry[data-tab=' + target + ']').show();
        } else if (isMobile && target) {
            // remove any old active filter styling
            $('.filter-content').removeClass('show-on-mobile');
            $('.filter-content-entry').removeClass('show-on-mobile');

            // add styling to current selected filter
            $('.filter-container').addClass('show-on-mobile');
            $('.filter-content').addClass('show-on-mobile');
            $('.filter-navigation').hide();
            $('.filter-content > .filter-content-entry[data-tab=' + target + ']').addClass('show-on-mobile');
        }
    });

    // Closes active filter tab on mobile
    $('.filter-content-entry-mobile-title .back').off().on('click', function ($event) {
        $event.preventDefault();
        $('.filter-container').removeClass('show-on-mobile');
        $('.filter-navigation').removeAttr("style");
        $('.filter-content').removeClass('show-on-mobile');
        $('.filter-content-entry').removeClass('show-on-mobile');
    });

    $('#filter-toggle').off().on('click', function () {
        isMobileActive = true;
        $('#filter-wrapper').toggleClass('show-filter');
    });

    $('#location-toggle').off().on('click', function () {
        isMobileActive = true;
        $('#filter-wrapper').toggleClass('show-filter');
        $('.filter-container').addClass('show-on-mobile');
        $('.filter-content').addClass('show-on-mobile');
        $('.filter-navigation').hide();
        $('.filter-content > .filter-content-entry[data-tab="location"]').addClass('show-on-mobile');
    });

    $('#filter-cancel, #filter-show-results').off().on('click', function () {
        isDesktopActive = false;
        isMobileActive = false;
        clearAll();
    });

    $('#close-filter-search').on('close', function () {
        isDesktopActive = false;
        isMobileActive = false;
        clearAll();
    })

    // Calculates if is mobile or not
    $(window).resize(function () {
        isMobile = $(window).width() < 576;

        if (isMobile && isDesktopActive) {
            isDesktopActive = false;
            clearDesktop();
        } else if (!isMobile && isMobileActive) {
            isMobileActive = false;
            clearMobile();
        }
    });

    // Trigger window resize to check on load
    $(window).resize();

    function calculateSelectWidth() {
        let selectedCountry = $('.search-order-by select').children("option:selected").text();
        $('.search-order-by--width-reference select option:selected').text(selectedCountry);
        $('.search-order-by').css('width', $('.search-order-by--width-reference').width());
    }

    calculateSelectWidth();

    $('.search-order-by select').off().on('change', function () {
        calculateSelectWidth();
    });
}

export default jQueryLogic;
